<script setup>
import { defineProps, ref, watch, defineEmits } from 'vue';

const goal = ref(props.data);
const props = defineProps(['data', 'skillName']);
const emit = defineEmits(['close']);
const tabs = ref([
	{
		name: 'Nội dung mục tiêu',
	},
	{
		name: 'Hoạt động',
	},
]);
const tab = ref(0);
const errorActivities = ref(['']);

watch(
	() => props.data,
	(value) => {
		goal.value = value;
	}
);

const addActivity = () => {
	if (goal.value.activities.length > 0) {
		for (let g in goal.value.activities) {
			if (!goal.value.activities[g].name) {
				errorActivities.value[g] = 'Tên hoạt động không được trống';
				setTimeout(() => {
					errorActivities.value[g] = '';
				}, 2000);
				return;
			}
		}
	}
	goal.value.activities.push({
		name: '',
	});
};

const removeActivity = (index) => {
	goal.value.activities.splice(index, 1);
};

const submit = () => {
	goal.value.activities = goal.value.activities.filter((i) => i.name);
	emit('close');
};
</script>
<template>
	<div class="fixed inset-y-0 right-0 flex side-over z-50">
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M1.5 5.5C1.5 4.67157 2.17157 4 3 4H21C21.8284 4 22.5 4.67157 22.5 5.5C22.5 6.32843 21.8284 7 21 7H3C2.17157 7 1.5 6.32843 1.5 5.5Z"
								fill="#94A3B8"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M3.5 12C3.5 11.1716 4.17157 10.5 5 10.5H19C19.8284 10.5 20.5 11.1716 20.5 12C20.5 12.8284 19.8284 13.5 19 13.5H5C4.17157 13.5 3.5 12.8284 3.5 12Z"
								fill="#94A3B8"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M6.5 18C6.5 17.1716 7.17157 16.5 8 16.5H16C16.8284 16.5 17.5 17.1716 17.5 18C17.5 18.8284 16.8284 19.5 16 19.5H8C7.17157 19.5 6.5 18.8284 6.5 18Z"
								fill="#94A3B8"
							/>
						</svg>

						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Chỉnh sửa Mục tiêu
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				class="sideover-content mt-6 relative flex-1 px-4 sm:px-6"
				style="scroll-behavior: smooth"
				id="slide-over"
			>
				<div class="w-full mb-10">
					<div class="border-b border-neutral-200">
						<nav
							aria-label="Tabs"
							class="-mb-px flex space-x-8 tabs"
						>
							<div
								v-for="(t, index) in tabs"
								:key="index"
								:class="
									tab === index
										? 'border-b-2 text-yellow-700 border-yellow-500'
										: 'text-neutral-500'
								"
								class="
									border-transparent
									hover:text-yellow-700
									hover:border-yellow-500
									whitespace-nowrap
									py-3
									px-1
									border-b-2
									font-semibold
									cursor-pointer
								"
								@click="tab = index"
							>
								<div class="flex items-center gap-2">
									<div>{{ t.name }}</div>
								</div>
							</div>
						</nav>
					</div>
				</div>
				<div v-show="tab === 0">
					<div class="w-full mt-5">
						<div class="font-semibold text-neutral-600 mb-2">
							Lĩnh vực*
						</div>
						<div
							class="
								skill
								mb-6
								text-gray-700
								flex
								items-center
								pl-4
							"
						>
							{{ props.skillName }}
						</div>
						<div class="font-semibold text-neutral-600 mb-2">
							Nội dung*
						</div>
						<div class="mb-4">
							<textarea
								placeholder="Nội dung mục tiêu"
								v-model="goal.name"
								rows="10"
							>
							</textarea>
						</div>
					</div>
				</div>
				<div v-if="tab === 1">
					<div class="flex items-center justify-end mt-6">
						<button
							@click="addActivity"
							type="button"
							class="
								button-p
								text-center
								bg-none
								shadow-none
								flex
								items-center
								justify-center
								btn--ghost
								w-fit
							"
						>
							<svg
								class="mr-2 -mt-1"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
									fill="#E5A42B"
								/>
							</svg>
							<span>Thêm hoạt động</span>
						</button>
					</div>
					<div
						class="mt-6"
						v-for="(activity, index) in goal.activities"
						:key="index"
					>
						<div class="flex items-center justify-between">
							<div class="font-semibold text-neutral-500 mb-2">
								Hoạt động {{ index + 1 }}
							</div>
						</div>
						<textarea
							placeholder="Tên hoạt động"
							v-model="activity.name"
							:class="errorActivities[index] ? 'text-error' : ''"
						>
						</textarea>
						<div
							class="text-sienna-600 text-sm"
							v-if="errorActivities[index]"
						>
							{{ errorActivities[index] }}
						</div>
						<div class="flex items-center justify-end">
							<div
								@click="removeActivity(index)"
								class="
									flex
									items-center
									text-yellow-600
									hover:text-yellow-700
									font-semibold
									cursor-pointer
									text-sm
									gap-2
								"
							>
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
										fill="currentColor"
									/>
								</svg>
								<div>XOÁ</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<div>
						<button
							type="button"
							class="button-p text-center w-fit"
							@click="submit"
							:disabled="!goal.name"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped lang="scss">
@import '@/assets/styles/responsive';
.side-over {
	width: 100vw;
	padding-left: 0;

	@include media-breakpoint-up(md) {
		width: 600px;
	}
}
.sideover-content {
	height: calc(100vh - 300px);
	overflow-y: auto;
}
.skill {
	background: #f1f5f9;
	border: 0.5px solid #f8fafc;
	box-shadow: 0px 0px 1px 0px #32324733;
	box-shadow: 0px 1px 2px 0px #32324714;
	border-radius: 4px;
	height: 44px;
}
</style>
